export const getTimeDiff = (laterDate: Date) => {
  let diff = laterDate.getTime() - new Date().getTime()
  let hours = new Date(diff).getHours() - 1
  if (laterDate.getDay() - new Date().getDay() == 1 && hours == -1) {
    hours = 23
  }
  let minutes = new Date(diff).getMinutes()
  return `${hours}h ${minutes}m`
}
